import { axios } from '@/utils/request'
import user from '@/config/debug.config'

const api = {
  // NOTE:2025.8.20修改 顶象替换为新的验证码接口
  // Login: '/5c9caf3111ea8',
  getCaptchaCode: '/68a58d21a3f1a',
  Login: '/68a58c999b2e0',
  Smslogin: '/5c9d90628affb',
  Logout: '/auth/logout',
  ForgePassword: '/auth/forge-password',
  Register: '/5c9d825b7e691',
  twoStepCode: '/auth/2step-code',
  // 验证码登录接口
  // SendSms: '/5c9d86eeecc05',
  SendSms: '/68a7cf6e4c1db',
  // 注册发送验证码接口
  // SendRegSms: '/5c9d843d817a2',
  SendRegSms: '/68a7cdfbded56',
  resetPassword: '/5c9d8da433492',
  // get my info
  UserInfo: '/5c9d81486c58f',
  // 新增欢喜物流注册的短信
  // hxwlLogin: '/63903f1dcac4b',
  hxwlLogin: '/68a80f345c846',
}

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function login(postData) {
  // const parameter = {
  // username,
  // password,
  // captchaToken: token
  // }
  return axios({
    url: api.Login,
    method: 'post',
    data: postData,
  })
}

export function getCaptchaCode() {
  return axios({
    url: api.getCaptchaCode,
    method: 'post',
  })
}

export function smslogin({ mobile, captcha }) {
  const parameter = {
    mobile,
    captcha,
  }
  return axios({
    url: api.Smslogin,
    method: 'post',
    data: parameter,
  })
}

export function register({ captcha, mobile, password, confirmPassword, invite_code }) {
  const parameter = {
    captcha,
    mobile,
    password,
    confirm_password: confirmPassword,
    invite_code: invite_code,
  }
  return axios({
    url: api.Register,
    method: 'post',
    data: parameter,
  })
}
// 重置密码
export function resetPassword({ captcha, mobile, password, confirmPassword }) {
  const parameter = {
    captcha,
    mobile,
    password,
    confirm_password: confirmPassword,
  }
  return axios({
    url: api.resetPassword,
    method: 'post',
    data: parameter,
  })
}
// 登录短信
export function getSmsCaptcha({ mobile, captchaCode, captchaId }) {
  const parameter = {
    phoneNumber: mobile,
    captchaCode,
    captchaId,
  }
  return axios({
    url: api.SendSms,
    method: 'post',
    data: parameter,
  })
}
// 注册短信
export function getRegSmsCaptcha({ mobile, captchaCode, captchaId }) {
  const parameter = {
    phoneNumber: mobile,
    captchaCode,
    captchaId,
  }
  return axios({
    url: api.SendRegSms,
    // method: 'get',
    method: 'POST',
    data: parameter,
  })
}

// 欢喜物流注册短信
export function hxwlLogin({ mobile, captchaCode, captchaId }) {
  const parameter = {
    phoneNumber: mobile,
    captchaCode,
    captchaId,
  }
  return axios({
    url: api.hxwlLogin,
    method: 'post',
    data: parameter,
  })
}

export function getInfo() {
  return axios({
    url: api.UserInfo,
    method: 'get',
  }).then(res => {
    // console.log(res.data)
    if (res.code === 1 && res.data) {
      res.data.avatar = 'https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png'
      res.data.id = res.data.user.id
      res.data.role = {
        id: 'robot',
        name: '机器人',
        permissions: [
          {
            permissionId: user.includes(res.data.user.username) ? 'debug' : 'user',
          },
        ],
      }
    }
    return res
  })
}

export function logout() {
  return axios({
    url: '/auth/logout',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  })
}

/**
 * get user 2step code open?
 * @param parameter {*}
 */
export function get2step(parameter) {
  return axios({
    url: api.twoStepCode,
    method: 'post',
    data: parameter,
  })
}
